import { useNavigate } from "react-router-dom";
import { articles } from "@/mocks/categories";

export default function ArticleGrid() {
  const navigate = useNavigate();

  const displayArticles = articles.slice(1);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-xs font-medium text-accent-700 bg-accent-50 mb-4 whitespace-nowrap">
            Blog &amp; Poradniki
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Więcej artykułów o USFans Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Sprawdź nasze szczegółowe poradniki i analizy. Dowiedz się więcej o organizacji danych, automatyzacji i bezpieczeństwie.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {displayArticles.map((article) => (
            <button
              key={article.slug}
              onClick={() => {
                navigate(`/artykul/${article.slug}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:shadow-md transition-all duration-300 cursor-pointer text-left"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-xs font-medium text-accent-700 mb-2">
                  {article.tag}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center gap-1.5 mt-3 text-xs font-medium text-primary-600">
                  <span>Czytaj więcej</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}